// Common components
export * from './components/common';

// Auth components
export * from './components/auth';

// Therapist components
export * from './components/therapist';

// Search components
export * from './components/search';

// Landing page components
export * from './components/landing';

// Tools components
export * from './components/tools';

// Support ticket components (form, thread, floating help button)
export * from './components/support';

// Error handling components and hooks
export { ErrorBoundary } from './components/ErrorBoundary';
export { useErrorHandler, useAsyncError } from './hooks/useErrorHandler';

// Re-export from root for backward compatibility (to be removed later)
export { Button } from './components/common/button';
export { Card } from './components/common/card';
export { Checkbox } from './components/common/Checkbox';
export { Code } from './components/common/code';
export { Collapsible } from './components/common/collapsible';
export { Footer } from './components/common/footer';
export { Header } from './components/common/header';
export { Input } from './components/common/input';
export { ProgressBar } from './components/common/ProgressBar';
export { SectionCard } from './components/common/SectionCard';
export { Select } from './components/common/select';
export { SidebarNav } from './components/common/SidebarNav';
export type { NavItem } from './components/common/SidebarNav';
export { Textarea } from './components/common/Textarea';